/* Pulpo — variantes completas en productos con mas de 250 variantes.
 *
 * Shopify corta product.variants en 250 dentro de Liquid. En los productos con
 * mas colores el tema no conoce las variantes que quedan fuera: al elegir uno
 * de esos colores no cambia la foto, no cambia la URL y la rejilla de tallas se
 * queda en blanco. Este script completa la lista con la Storefront API.
 */
(function () {
  'use strict';

  var LIMITE = 250;

  function handleProducto() {
    var m = location.pathname.match(/\/products\/([^\/?#]+)/);
    return m ? m[1] : null;
  }

  function token() {
    if (window.PULPO_SF_TOKEN) return window.PULPO_SF_TOKEN;
    var e = document.querySelector('[storefront-access-token]');
    return e ? e.getAttribute('storefront-access-token') : null;
  }

  function selector() {
    return document.querySelector('variant-radios-detail, variant-radios, variant-selects');
  }

  function urlDeImg(img) {
    var u = img.getAttribute('src') || img.getAttribute('data-src') || img.currentSrc || '';
    if (!u) {
      var ss = img.getAttribute('srcset') || img.getAttribute('data-srcset') || '';
      if (ss) u = ss.split(',')[0].trim().split(' ')[0];
    }
    return u;
  }

  function nombreFichero(u) {
    return (u || '').split('/').pop().split('?')[0];
  }

  function mapaMedios() {
    var mapa = {};
    document.querySelectorAll('[data-media-id]').forEach(function (el) {
      var img = el.querySelector('img');
      if (!img) return;
      var u = urlDeImg(img);
      var f = nombreFichero(u);
      if (!f || mapa[f]) return;
      var id = parseInt(String(el.getAttribute('data-media-id')).split('-').pop(), 10);
      if (!id) return;
      mapa[f] = { id: id, src: u.split('?')[0], alt: img.alt || '' };
    });
    return mapa;
  }

  var CONSULTA = 'query PulpoVariantes($h: String!, $c: String) {'
    + ' product(handle: $h) {'
    + '   options { name }'
    + '   variants(first: 250, after: $c) {'
    + '     pageInfo { hasNextPage endCursor }'
    + '     nodes { id title sku availableForSale quantityAvailable'
    + '       price { amount } compareAtPrice { amount }'
    + '       selectedOptions { name value } image { url } }'
    + '   } } }';

  function traerTodas(tok, h) {
    var todas = [];
    var nombres = null;

    function pagina(cursor) {
      return fetch('/api/2024-10/graphql.json', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': tok },
        body: JSON.stringify({ query: CONSULTA, variables: { h: h, c: cursor } })
      }).then(function (r) { return r.json(); }).then(function (j) {
        var p = j && j.data && j.data.product;
        if (!p) return null;
        if (!nombres) nombres = p.options.map(function (o) { return o.name; });
        todas = todas.concat(p.variants.nodes);
        if (p.variants.pageInfo.hasNextPage && todas.length < 5000) {
          return pagina(p.variants.pageInfo.endCursor);
        }
        return { nombres: nombres, variantes: todas };
      });
    }

    return pagina(null);
  }

  function completar(datos, base, medios) {
    var yaEstan = {};
    base.forEach(function (v) { yaEstan[v.id] = true; });
    var modelo = base[0] || {};
    var nuevas = [];

    datos.variantes.forEach(function (v) {
      var id = parseInt(v.id.split('/').pop(), 10);
      if (!id || yaEstan[id]) return;

      var valores = {};
      v.selectedOptions.forEach(function (o) { valores[o.name] = o.value; });
      var opciones = datos.nombres.map(function (n) { return valores[n]; });

      var m = v.image ? medios[nombreFichero(v.image.url)] : null;
      var media = m ? {
        alt: m.alt, id: m.id, position: 1,
        preview_image: { aspect_ratio: 1, height: 1000, width: 1000, src: m.src }
      } : null;

      nuevas.push({
        id: id,
        title: v.title,
        option1: opciones[0] || null,
        option2: opciones[1] || null,
        option3: opciones[2] || null,
        sku: v.sku,
        requires_shipping: true,
        taxable: true,
        featured_image: m ? { id: m.id, src: m.src, alt: m.alt, width: 1000, height: 1000 } : null,
        available: v.availableForSale,
        name: v.title,
        public_title: v.title,
        options: opciones,
        price: Math.round(parseFloat(v.price.amount) * 100),
        weight: modelo.weight || 0,
        compare_at_price: v.compareAtPrice ? Math.round(parseFloat(v.compareAtPrice.amount) * 100) : null,
        inventory_quantity: v.quantityAvailable == null ? 0 : v.quantityAvailable,
        inventory_management: 'shopify',
        inventory_policy: 'deny',
        barcode: null,
        featured_media: media,
        requires_selling_plan: false,
        selling_plan_allocations: [],
        quantity_rule: modelo.quantity_rule || { min: 1, max: null, increment: 1 }
      });
    });

    return nuevas;
  }

  function avisarRejilla(lista) {
    var paraRejilla = lista.map(function (v) {
      return { id: v.id, o: v.options, a: v.available, q: v.inventory_quantity, p: v.price };
    });
    window.PULPO_VARIANTES_COMPLETAS = paraRejilla;
    if (window.PULPO_BULK && typeof window.PULPO_BULK.setVariants === 'function') {
      window.PULPO_BULK.setVariants(paraRejilla);
    }
  }

  function arrancar() {
    var h = handleProducto();
    if (!h) return;

    var el = selector();
    if (!el) return;

    /* El tema no rellena variantData hasta que alguien llama a getVariantData().
       Se fuerza aqui para no rendirse antes de tiempo. */
    var base = el.variantData;
    if ((!base || !base.length) && typeof el.getVariantData === 'function') {
      try { base = el.getVariantData(); } catch (e) {}
    }
    if (!base || !base.length) return;

    var tok = token();
    if (!tok) {
      console.warn('[pulpo] faltan variantes por el limite de 250 y no hay token de Storefront');
      return;
    }

    traerTodas(tok, h).then(function (datos) {
      if (!datos || !datos.variantes.length) return;
      var medios = mapaMedios();
      /* Shopify tapa inventory_quantity a 90 en el escaparate. La Storefront
         API si devuelve la cantidad real, asi que se corrigen todas. */
      var real = {};
      datos.variantes.forEach(function (v) {
        var id = parseInt(v.id.split('/').pop(), 10);
        if (id) real[id] = { q: v.quantityAvailable, a: v.availableForSale };
      });
      base.forEach(function (v) {
        var r = real[v.id];
        if (!r) return;
        if (r.q != null) v.inventory_quantity = r.q;
        if (r.a != null) v.available = r.a;
      });

      var nuevas = completar(datos, base, medios);
      var completa = base.concat(nuevas);
      el.variantData = completa;

      /* Tambien se reescribe el JSON de la ficha: si el tema vuelve a leerlo,
         encuentra la lista entera y no las 250 recortadas. */
      var sc = el.querySelector('script[type="application/json"]:not([data-selected-variant])')
            || el.querySelector('script[type="application/json"]');
      if (sc) { try { sc.textContent = JSON.stringify(completa); } catch (e) {} }

      avisarRejilla(completa);

      var marcado = document.querySelector('variant-radios-detail input:checked, variant-radios input:checked');
      if (marcado) marcado.dispatchEvent(new Event('change', { bubbles: true }));

      document.dispatchEvent(new CustomEvent('pulpo:variantes-completas', {
        detail: { total: completa.length, anadidas: nuevas.length }
      }));
    }).catch(function (e) {
      console.warn('[pulpo] no se han podido completar las variantes', e);
    });
  }

  /* El selector es un custom element: puede tardar en tener variantData.
     Se sondea hasta 15 s antes de rendirse. */
  var intentos = 0;
  function esperar() {
    var el = selector();
    if (el && (el.variantData || typeof el.getVariantData === 'function')) { arrancar(); return; }
    if (++intentos < 60) setTimeout(esperar, 250);
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', esperar);
  } else {
    esperar();
  }
})();
